const listeners = new Set();
let access = { tenant: '', enabled: false };

export function setSftpAccess(tenant, enabled) {
  access = { tenant: tenant || '', enabled: !!enabled };
  listeners.forEach((listener) => listener(access));
}

export function subscribeSftpAccess(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
